import { render, staticRenderFns } from "./VabMenuItem.vue?vue&type=template&id=1915d64a&scoped=true"
import script from "./VabMenuItem.vue?vue&type=script&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VabMenuItem.vue?vue&type=style&index=0&id=1915d64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915d64a",
  null
  
)

export default component.exports